import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="flex flex-col items-center text-center space-y-8 md:space-y-12" data-id="element-35">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="space-y-6" data-id="element-36">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight text-[#3D2B1F]" data-id="element-37">
          El Fin de la <span className="text-[#C4704B]" data-id="element-38">Supermujer</span>
        </h1>

        <h2 className="text-xl md:text-2xl text-[#3D2B1F]/80 font-medium max-w-2xl mx-auto" data-id="element-39">
          El Protocolo para Soltar la Carga Mental y Recuperar tu Vida
        </h2>

        <p className="text-lg md:text-xl text-[#C4704B] font-serif italic max-w-xl mx-auto" data-id="element-40">
          Para la mujer que lo resuelve todo, excepto cómo dejar de sentirse
          agotada por dentro.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      rotate: -1
    }} animate={{
      opacity: 1,
      scale: 1,
      rotate: 0
    }} transition={{
      duration: 1,
      delay: 0.2,
      ease: 'easeOut'
    }} className="relative w-full max-w-md mx-auto" data-id="element-41">
        <a href="#pricing" className="inline-block mb-6 bg-[#C4704B] text-white font-bold text-lg py-3 px-8 rounded-full shadow-lg hover:bg-[#B06040] hover:shadow-xl transition-all duration-300" data-id="element-42">
          Descubrir el Sistema
        </a>
        <div className="absolute inset-0 top-16 bg-[#C4704B]/10 rounded-xl transform rotate-3 scale-105 blur-lg" data-id="element-43" />
        <img src="https://cdn.magicpatterns.com/uploads/f1zUJdUcHhK1Fsu4Sae3PZ/Foto_1.png" alt="El Fin de la Supermujer en tablet" className="relative z-10 w-full h-auto rounded-lg shadow-2xl transform transition-transform hover:scale-[1.01] duration-500" data-id="element-44" />
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 0.6
    }} className="prose prose-lg prose-p:text-[#3D2B1F]/90 prose-p:font-body max-w-2xl mx-auto text-left md:text-justify leading-relaxed" data-id="element-45">
        <p data-id="element-46">
          Si hoy te preguntaran cómo estás, probablemente responderías "bien,
          cansada, lo normal". Pero ambas sabemos que no es normal sentir que la
          vida es una lista de pendientes que nunca termina.
        </p>
        <p data-id="element-47">
          Sé lo que es encerrarse en el baño a llorar cinco minutos solo para
          recuperar el aliento, porque "una sola tarea más" se siente como el
          fin del mundo. No estás fallando. Estás sobrecargada.
        </p>
      </motion.div>
    </section>;
}